import { useEffect, useRef } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Login } from './components/Login'
import { useAuth } from './context/AuthContext'
import Dashboard from './pages/Dashboard'
import Usuarios from './pages/Usuarios'
import Perfiles from './pages/Perfiles'
import Seguridad from './pages/Seguridad'
import Licencias from './pages/Licencias'
import Inventario from './pages/Inventario'
import Movimientos from './pages/Movimientos'
import Pedidos from './pages/Pedidos'
import { Analiticas } from './pages/Analiticas'
import Clientes from './pages/Clientes'
import Proveedores from './pages/Proveedores'
import Almacenes from './pages/Almacenes'
import Ubicaciones from './pages/Ubicaciones'
import Productos from './pages/Productos'
import Empresas from './pages/Empresas'
import Transportistas from './pages/Transportistas'
import Vehiculos from './pages/Vehiculos'
import Recepciones from './pages/Recepciones'
import Surtido from './pages/Surtido'
import Packing from './pages/Packing'
import Embarques from './pages/Embarques'
import Rutas from './pages/Rutas'
import Transporte from './pages/Transporte'
import Reportes from './pages/Reportes'
import Configuracion from './pages/Configuracion'

function RastreadorRuta() {
  const { usuario, inicializando } = useAuth()
  const { pathname } = useLocation()
  const navegar = useNavigate()
  const yaRestauro = useRef(false)

  useEffect(() => {
    if (yaRestauro.current) return
    if (!inicializando && usuario && pathname === '/') {
      yaRestauro.current = true
      const ruta = localStorage.getItem('logistica:ultima-ruta')
      if (ruta && ruta !== '/') {
        navegar(ruta, { replace: true })
      }
    }
  }, [inicializando, usuario, pathname, navegar])

  useEffect(() => {
    if (usuario && pathname !== '/login') {
      localStorage.setItem('logistica:ultima-ruta', pathname)
    }
  }, [usuario, pathname])
  return null
}

function App() {
  return (
    <BrowserRouter>
      <RastreadorRuta />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="inventario" element={<Inventario />} />
          <Route path="movimientos" element={<Movimientos />} />
          <Route path="pedidos" element={<Pedidos />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="perfiles" element={<Perfiles />} />
          <Route path="roles" element={<Seguridad />} />
          <Route path="licencias" element={<Licencias />} />
          <Route path="analiticas" element={<Analiticas />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="proveedores" element={<Proveedores />} />
          <Route path="almacenes" element={<Almacenes />} />
          <Route path="ubicaciones" element={<Ubicaciones />} />
          <Route path="productos" element={<Productos />} />
          <Route path="empresas" element={<Empresas />} />
          <Route path="transportistas" element={<Transportistas />} />
          <Route path="vehiculos" element={<Vehiculos />} />
          <Route path="recepciones" element={<Recepciones />} />
          <Route path="surtido" element={<Surtido />} />
          <Route path="packing" element={<Packing />} />
          <Route path="embarques" element={<Embarques />} />
          <Route path="rutas" element={<Rutas />} />
          <Route path="transporte" element={<Transporte />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="configuracion" element={<Configuracion />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
